import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./dashboard.css";
import "./Assets/font-icons/icons.min.css";
import "./Assets/css/select.css";
import "./Assets/css/button.css";
import {BrowserRouter} from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </>
);

reportWebVitals();
